import deepExtend from '../utilities/deepExtend.js';
import closestParent from '../utilities//closestParent.js';

const triggerClickHandler = function (target, options, containers) {
  let isLocked;

  if (closestParent(target, options.selectors.jsTrigger)) {
    event.preventDefault();

    if (document.body.classList.contains(options.classes.hasActive)) {
      document.body.classList.remove(options.classes.hasActive);
      isLocked = false;
    } else {
      document.body.classList.add(options.classes.hasActive);
      isLocked = true;
    }

    const lockEvent = new CustomEvent('EuroplastMenu.toggle', {
      detail: { locked: isLocked },
    });
    document.dispatchEvent(lockEvent);
  } else if (
    target.classList.contains(options.classes.inner) ||
    closestParent(target, options.selectors.jsClose)
  ) {
    event.preventDefault();

    document.body.classList.remove(options.classes.hasActive);
    isLocked = false;

    const lockEvent = new CustomEvent('EuroplastMenu.toggle', {
      detail: { locked: isLocked },
    });
    document.dispatchEvent(lockEvent);
  } else if (closestParent(target, options.selectors.jsOpenLevel)) {
    event.preventDefault();

    const parent = closestParent(target, options.selectors.jsOpenLevel);
    const triggerTarget = document.querySelector(parent.getAttribute('href'));

    if (target.classList.contains(options.classes.level1MenuItem)) {
      document.body.setAttribute('data-w-menu-level', '2');

      for (const item of containers.level1MenuItems) {
        item.classList.remove(options.classes.wakActive);
      }
      for (const item of containers.level2Content) {
        item.classList.remove(options.classes.wakDisplay);
      }
      for (const item of containers.level3Content) {
        item.classList.remove(options.classes.wakDisplay);
      }

      const sub = triggerTarget.querySelector(
        options.selectors.level2MenuItem + '.' + options.classes.wakActive
      );
      if (sub) {
        const subTarget = document.querySelector(sub.getAttribute('href'));
        if (subTarget) {
          subTarget.classList.add(options.classes.wakDisplay);
        }
      }
    }
    if (target.classList.contains(options.classes.level2MenuItem)) {
      document.body.setAttribute('data-w-menu-level', '3');

      for (const item of containers.level2MenuItems) {
        item.classList.remove(options.classes.wakActive);
      }
      for (const item of containers.level3Content) {
        item.classList.remove(options.classes.wakDisplay);
      }
    }

    target.classList.add(options.classes.wakActive);
    triggerTarget.classList.add(options.classes.wakDisplay);
  } else if (closestParent(target, options.selectors.jsBack)) {
    let level = parseInt(document.body.getAttribute('data-w-menu-level'));
    document.body.setAttribute('data-w-menu-level', level - 1);
  }
};

export default function EuroplastMenuController() {
  const defaults = {
    selectors: {
      container: '.w-site-menu',
      jsTrigger: '.w-js-trigger-menu',
      jsClose: '#wak_menu_close',
      jsBack: '.w-js-trigger-back',
      jsOpenLevel: '.w-js-trigger-level-2, .w-js-trigger-level-3',
      level1: '#lev1',
      level2: '#lev2',
      level3: '#lev3',
      level1MenuItem: '.w-js-trigger-level-2',
      level2MenuItem: '.w-js-trigger-level-3',
      level2Content: '.level2_content',
      level3Content: '.level3_content',
    },
    classes: {
      inner: 'w-site-menu__inner',
      hasActive: 'w-has-menu',
      wakDisplay: 'displayed',
      wakActive: 'active',
      level1MenuItem: 'w-js-trigger-level-2',
      level2MenuItem: 'w-js-trigger-level-3',
      level2Content: 'level2_content',
      level3Content: 'level3_content',
    },
  };
  let options = {};

  const containers = {
    allMenuItems: null,
    level1MenuItems: null,
    level2MenuItems: null,
    allContent: null,
    level2Content: null,
    level3Content: null,
  };

  return {
    init: function (params = {}) {
      options = deepExtend(defaults, params);

      containers.allMenuItems = document.querySelectorAll(
        options.selectors.jsOpenLevel
      );
      containers.level1MenuItems = document.querySelectorAll(
        options.selectors.level1MenuItem
      );
      containers.level2MenuItems = document.querySelectorAll(
        options.selectors.level2MenuItem
      );
      containers.allContent = document.querySelectorAll(
        options.selectors.level2Content + ', ' + options.selectors.level3Content
      );
      containers.level2Content = document.querySelectorAll(
        options.selectors.level2Content
      );
      containers.level3Content = document.querySelectorAll(
        options.selectors.level3Content
      );

      // initial init
      const level1Link = document.querySelector(
        options.selectors.level1 + ' .menu_level1_item:first-child a'
      );
      level1Link.classList.add(options.classes.wakActive);
      const level2 = document.querySelector(
        options.selectors.level2 + ' .level2_content:first-child'
      );
      level2.classList.add(options.classes.wakDisplay);
      const level2Link = document.querySelector(
        options.selectors.level2 + ' .menu_level2_item:first-child a'
      );
      level2Link.classList.add(options.classes.wakActive);
      const level3 = document.querySelector(
        options.selectors.level3 + ' .level3_content:first-child'
      );
      level3.classList.add(options.classes.wakDisplay);
      document.body.setAttribute('data-w-menu-level', '1');

      document.addEventListener('click', (event) => {
        triggerClickHandler(event.target, options, containers);

        event.stopPropagation();
      });
    },
  };
}
